function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var l = Object.defineProperty;
var n = Object.getOwnPropertySymbols;
var w = Object.prototype.hasOwnProperty,
    g = Object.prototype.propertyIsEnumerable;

var e = function e(o, C, t) {
  return C in o ? l(o, C, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : o[C] = t;
},
    i = function i(o, C) {
  for (var t in C || (C = {})) {
    w.call(C, t) && e(o, t, C[t]);
  }

  if (n) {
    var _iterator = _createForOfIteratorHelper(n(C)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var t = _step.value;
        g.call(C, t) && e(o, t, C[t]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return o;
};

import * as r from "react";

function p(o) {
  return r.createElement("svg", i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o), r.createElement("path", {
    d: "M17.6 9.10278L19.44 5.92278C19.6 5.61278 19.48 5.23278 19.18 5.07278C18.89 4.92278 18.53 5.01278 18.35 5.29278L16.47 8.53278C13.61 7.32278 10.39 7.32278 7.53 8.53278L5.65 5.29278C5.46 5.00278 5.07 4.91278 4.78 5.09278C4.5 5.27278 4.41 5.63278 4.56 5.92278L6.4 9.10278C3.3 10.8728 1.28 14.0628 1 17.6228H23C22.72 14.0628 20.7 10.8728 17.6 9.10278ZM7 14.8728C6.31 14.8728 5.75 14.3128 5.75 13.6228C5.75 12.9328 6.31 12.3728 7 12.3728C7.69 12.3728 8.25 12.9328 8.25 13.6228C8.25 14.3128 7.69 14.8728 7 14.8728ZM17 14.8728C16.31 14.8728 15.75 14.3128 15.75 13.6228C15.75 12.9328 16.31 12.3728 17 12.3728C17.69 12.3728 18.25 12.9328 18.25 13.6228C18.25 14.3128 17.69 14.8728 17 14.8728Z",
    fill: "black"
  }));
}

export { p as ReactComponent };